import { useTranslation } from "react-i18next";
import { trackCTA } from "../../utils/analytics";
import { useSiteInfo } from "../../contexts/SiteInfoContext";
import routePaths from "../../routes/routePaths";

export default function CallToAction() {
  const { t } = useTranslation();
  const { siteInfo, loading } = useSiteInfo();

  if (loading) return null;
  if (!siteInfo) return null;

  return (
    <section className="bg-primary/5 py-12 px-4">
      <div className="max-w-2xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-extrabold text-primary mb-4">
          🎯 {t("cta.title")}
        </h2>
        <div className="flex flex-col sm:flex-row justify-center items-center gap-4 mt-6">
          <a
            href={routePaths.contact}
            onClick={() => trackCTA("Đăng ký học thử", "CTA Section")}
            className="
              bg-primary text-textButton font-extrabold py-3 px-7 rounded shadow-sm text-lg tracking-wide
              transition
              hover:bg-primary/90 hover:shadow
              focus:outline-none focus:ring-2 focus:ring-primary/30
              active:scale-95
            "
          >
            {t("cta.registerNow")}
          </a>
          <a
            href={siteInfo.zalo}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => trackCTA("Zalo Button", "CTA Section")}
            className="
              flex items-center gap-2 bg-card hover:bg-primary/10 text-primary font-bold py-3 px-6 rounded shadow-sm
              border border-primary transition text-lg
              focus:outline-none focus:ring-2 focus:ring-primary/20
              active:scale-95
            "
          >
            <span className="bg-primary/20 rounded-full p-1">
              <img src="/zalo-icon.svg" alt="Zalo" className="w-6 h-6" />
            </span>
            {t("cta.chatZalo")}
          </a>
        </div>
      </div>
    </section>
  );
}
